import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import moment from "moment";
import styled from "styled-components";
import { PercentInput, IntegerInput } from "components/Global/FastFormikMaterial";

const VerticalSpace = styled.div`
  height:32px;
  width:100%;
`;
const StyledPercentInput = styled(PercentInput)`
  & {
    width: 100%;
  }
`;
const StyledIntegerInput = styled(IntegerInput)`
  & {
    width: 100%;
  }
`;
class MakeWhole extends React.Component {
  componentDidMount() {
    const { openPeriod, percent } = this.props;
    this.setDescription(openPeriod, percent);
  }

  componentDidUpdate(prevProps) {
    const { openPeriod, percent } = this.props;
    const { openPeriod: prevOpenPeriod, percent: prevPercent } = prevProps;
    if (openPeriod !== prevOpenPeriod || percent !== prevPercent) {
      this.setDescription(openPeriod, percent);
    }
  }

  setDescription(openPeriod, percent) {
    if (percent && openPeriod) {
      const description = `${percent}% minimum penalty`;
      this.props.setDescription(description);
    } else {
      this.props.setDescription("No description");
    }
  }

  render() {
    const { index } = this.props;

    return (
      <>
        <Grid item xs={4}>
          <StyledPercentInput
            label="Minimum Prepayment"
            fieldName={`prepaymentSchedules[${index}].percent`}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={4}>
          <StyledIntegerInput
            label="Open Periods"
            fieldName={`prepaymentSchedules[${index}].openPeriod`}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={4}>
          <VerticalSpace />
          <StyledPercentInput
            label="Replacement Rate Spread"
            decimalScale={3}
            fieldName={`prepaymentSchedules[${index}].replacementRateSpread`}
          />
        </Grid>
      </>
    );
  }
}
export default MakeWhole;
